import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1c.315 0 .624.02.928.06.343.046.62.295.736.622l.675 1.897c.109.058.215.12.32.186l1.98-.365a.923.923 0 0 1 .905.326c.377.489.692 1.029.93 1.608a.922.922 0 0 1-.17.947l-1.307 1.535a5.106 5.106 0 0 1 0 .368l1.308 1.535a.922.922 0 0 1 .17.947 6.992 6.992 0 0 1-.93 1.608.923.923 0 0 1-.906.326l-1.98-.364c-.105.065-.211.127-.32.184l-.675 1.898a.923.923 0 0 1-.736.621 7.064 7.064 0 0 1-1.856 0 .923.923 0 0 1-.736-.62L5.66 12.42a5.017 5.017 0 0 1-.32-.184l-1.98.364a.923.923 0 0 1-.905-.326 6.994 6.994 0 0 1-.93-1.608.922.922 0 0 1 .17-.947l1.307-1.535a5.08 5.08 0 0 1 0-.368L1.695 6.281a.922.922 0 0 1-.17-.947c.24-.58.553-1.12.93-1.608a.923.923 0 0 1 .906-.326l1.98.365c.105-.066.211-.128.32-.185l.675-1.898a.923.923 0 0 1 .736-.621C7.376 1.021 7.685 1 8 1Zm0 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgGear = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgGear;
